module.exports = __webpack_public_path__ + "static/media/free_question_icon.91c25836.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/question_bank/free_question_icon.svg
// module id = 1041
// module chunks = 0